export default __webpack_public_path__ + "static/media/dashboard.7f70a6d9.png";